import type { FeedbackMessages } from './en';

const ru: FeedbackMessages = {
  qualified: {
    title: 'Благодарим Вас за участие в этом опросе!',
    text: 'Вы можете закрыть окно браузера.\n\nНадеемся увидеть Вас снова в ближайшее время.',
  },
  quotaFull: {
    title: 'Этот опрос закрыт',
    text: 'Благодарим Вас за интерес к нашему опросу.\n\nК сожалению, мы уже получили все необходимые ответы.\n\nНадеемся увидеть Вас в одном из наших будущих опросов!',
  },
  terminated: {
    title: 'Благодарим Вас за то, что поделились своим мнением!',
    text: 'Надеемся увидеть Вас в наших будущих опросах. А до тех пор желаем Вам отличного дня.\n\nПожалуйста, закройте это окно браузера.',
  },
  mismatch: {
    title: 'Благодарим Вас за интерес',
    text: 'К сожалению, Вы не входите в целевую группу для данного конкретного опроса.\n\nВы можете закрыть эту страницу.',
  },
  error: {
    title: 'Мы не можем обработать Ваш запрос',
    linkProblemDetailed:
      'Ссылка, по которой Вы перешли, работает некорректно. Пожалуйста, убедитесь, что ссылка в адресной строке совпадает с той, что была Вам предоставлена, и попробуйте снова.',
    linkProblemGeneric:
      'Ссылка, по которой Вы перешли, работает некорректно. Пожалуйста, попробуйте снова.',
    contactPerson:
      'Если проблема не исчезнет, пожалуйста, сообщите об этом человеку, от которого Вы получили ссылку.',
  },
};

export default ru;
